<template>
  <div :class="[baseCss, direction === 'up' ? `${baseCss}-direction-up` : null]" role="listbox" ref="autocomplete" :style="{width}">
    <async-form :form-data="{}" :class="['relative']" @submit="onSubmit">
      <container>
        <text-field
          @click="show"
          @keydown.up.prevent="onKey()"
          @keydown.down.prevent="onKey(true)"
          @input="emit"
          v-model="search"
          :disabled="disabled"
          :autofocus="autofocus"
          :clearable="clearable"
          :label="label"
          :placeholder="!hidden ? filtered[index] : placeholder"
          :color="color"
          :color-lightness="colorLightness"
          :icon-left="iconLeft"
          :icon-right="iconRight"
          :readonly="readonly"
          :hint="hint"
          :required="required"
          :hint-color="hintColor"
          :hint-color-lightness="hintColorLightness"
          :error="error"
          :error-color="errorColor"
          :error-color-lightness="errorColorLightness"
          :icon-provider="iconProvider" />
      </container>
      <transition name="fade">
        <card v-if="items && items.length" :elevation="elevation" :class="['absolute', `${baseCss}-dropdown`, hidden ? ['clip-0', 'opacity-0'] : null, 'transition-all', 'duration-500']" :style="{zIndex}">
          <card-text padding-off :class="['overflow-auto', `${baseCss}-items-container`]" :max-height="itemsMaxHeight">
            <list>
              <list-item :tabindex="i" @click="select(item, i)" v-for="(item, i) in filtered" v-if="item" :class="[index === i ? 'bcq-list-item-selected' : null]" :key="i">
                <list-item-content>
                  <list-item-content-sub-title v-html="item" :class="['px-2']" />
                </list-item-content>
              </list-item>
            </list>
          </card-text>
        </card>
      </transition>
    </async-form>
  </div>
</template>
<script>
import props from '../../mixins/props'
import methods from '../../mixins/methods'

export default {
  name: 'Autocomplete',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      search: '',
      index: 0,
      hidden: true,
      baseCss: this.componentBaseCss('autocomplete', [])
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    clearable: {
      type: Boolean
    },
    autofocus: {
      type: Boolean
    },
    iconLeft: {
      type: String
    },
    color: {
      type: String
    },
    colorLightness: {
      type: Number
    },
    iconRight: {
      type: String
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    itemsMaxHeight: {
      type: String,
      default: '220px'
    },
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {},
    disabled: {
      type: Boolean
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    width: {
      type: String
    },
    required: {
      type: Boolean
    },
    hint: {
      type: String
    },
    hintColor: {
      type: String
    },
    hintColorLightness: {
      type: Number
    },
    error: {
      type: String
    },
    errorColor: {
      type: String
    },
    errorColorLightness: {
      type: Number
    },
    readonly: {
      type: Boolean
    },
    fuzzySearch: {
      type: Boolean,
      default: false
    },
    sort: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: 'down',
      validator: value => {
        return [
          'down',
          'up'
        ].includes(value)
      }
    }
  },
  computed: {
    filtered () {
      const search = this.search.toLowerCase()
      const items = this.items.filter(item => {
        if (item) {
          item = item.toLowerCase()
          return this.fuzzySearch ? item.indexOf(search) > -1 : item.substring(0, search.length) === search
        }
      })
      return this.sort ? items.sort() : items
    }
  },
  watch: {
    search () {
      if (this.search === '') {
        this.index = 0
        this.$emit('clear', null)
      }
    },
    hidden () {
      this.$emit(this.hidden ? 'hide' : 'show', null)
    }
  },
  created () {
    document.addEventListener('click', this.documentClick)
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick)
  },
  methods: {
    select (item, index) {
      this.search = item
      this.index = index
      this.hide()
      this.emit()
    },
    show () {
      if (!this.disabled) {
        this.hidden = false
      }
    },
    hide () {
      this.hidden = true
    },
    documentClick (e) {
      let el = this.$refs['autocomplete']
      let target = e.target
      if (el !== target && !el.contains(target)) {
        this.hidden = true
      }
    },
    onSubmit () {
      this.search = this.filtered[this.index]
      this.hide()
      this.emit()
    },
    emit () {
      this.$emit('input', this.search)
    },
    onKey (down = false) {
      const index = this.index
      const length = this.items.length
      this.show()
      if (!down) {
        this.index = index === 0 ? 0 : this.index - 1
      } else {
        this.index = index === length - 1 ? length - 1 : this.index + 1
      }
      this.$nextTick(() => {
        this.scrollToElement(this.$el.querySelector('.bcq-list-item-selected'), {behavior: 'smooth'})
      })
    }
  }
}
</script>
<style>
.bcq-autocomplete.bcq-autocomplete-direction-up .bcq-autocomplete-dropdown
{
  bottom: 42px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/autocomplete/autocomplete.vue